module.exports = __webpack_public_path__ + "static/img/login3.2f2a3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/login3.png
// module id = 347
// module chunks = 0